import { Link } from 'react-router-dom';
import { PageHeader } from '../../components/layout/PageHeader';
import { KC } from '../../lib/kyckConnect/links';

// THE KYCKCONNECT LANDING PAGE for a signed-in staff member who is not an admin: the pages they can use. The admin Overview
// (every client's health) is admin-only data and replaces this for admins (OverviewPage renders this for everyone else).

export function KyckConnectHome() {
  return (
    <div>
      <PageHeader title="Overview" description="What needs Kyck across every client is for admins. Your KyckConnect pages are below." />
      <ul className="list-disc space-y-1 pl-5 text-sm text-slate-700" data-testid="kyckconnect-home">
        <li><Link className="underline" to={KC.approvals}>Approvals</Link>: replies waiting for a person.</li>
        <li><Link className="underline" to={KC.relayLog}>Lead relay log</Link>: every lead the relay received.</li>
        <li><Link className="underline" to={KC.numbers}>Numbers and pools</Link>: which numbers serve which clubs.</li>
        <li><Link className="underline" to={KC.reports}>Reports</Link>: the lead bot report.</li>
        <li>One club on its own: open its account page and the KyckConnect tab.</li>
      </ul>
    </div>
  );
}
